// wraps value in closure or returns closure

export const closure = (value: any) => {
	if (typeof value === 'function') {
		return value
	} else {
		return function closure() {
			return value
		}
	}
}
